import { t } from 'i18next';
import Money from '../Common/Money/Money';
import styles from '../ProductCard/ticketCard.module.css';

const EventProductCard = ({ product, handleIncrement, onInfoClick, hasMoreInfo = false }) => {
  const maxAvailable = product.stock;
  const isSoldOut = product.hasSoldOut || (maxAvailable && maxAvailable <= 0);

  const onProductClick = () => {
    if (!isSoldOut) {
      handleIncrement(product.id);
    }
  };

  return (
    <div
      className={styles.container}
      style={{
        border: '1px solid var(--color-deep-gray)',
        borderRadius: '10px',
      }}
      onClick={() => onProductClick()}
    >
      <div className='row m-0' style={{ minHeight: '86px' }}>
        {product.images && product.images.length > 0 ? (
          <div className='col-auto my-auto pl-2 pr-0'>
            <div className='position-relative'>
              <img
                src={product.images[0]}
                title={product.name}
                className={styles.productImage}
                alt={product.name}
              />

              {product.locationCode && (
                <div className={styles.productCode} style={{ backgroundColor: product.hexColor }}>
                  {product.locationCode}
                </div>
              )}
            </div>
          </div>
        ) : null}
        <div className={`col pl-2 text-truncate my-auto`}>
          <div className='text-secondary font-smaller'>
            {product.behavior === 'NO_GUARANTEED'
              ? t('fromGuests', { count: 1 })
              : t('upToGuests', { pax: product.pax })}
            {product.extraPax && product.extraPax > 0 ? (
              <span>
                {' '}
                + {product.extraPax} {t('extraGuests')} ($)
              </span>
            ) : null}
          </div>
          <div className={`fw-semibold font-medium text-truncate`}>{product.name}</div>
          {product.prices.consumption > 0 && (
            <div className={`font-smaller text-secondary text-truncate`}>
              {t('includes')}{' '}
              <Money mr='0' value={product.prices.consumption} lowDecimals decimal={false} />{' '}
              {t('forConsumption')}
            </div>
          )}
        </div>

        {isSoldOut ? (
          <div className='col-auto my-auto'>
            <div className={styles.soldOutLabel}>{t('soldOut')}</div>
          </div>
        ) : (
          <div className={`col-auto my-auto pl-0 fw-semibold font-normal`}>
            {product.behavior === 'NO_GUARANTEED' ? (
              <span className='text-lowercase'>{t('request')}</span>
            ) : (
              <Money value={product.prices.price} lowDecimals decimal={false} />
            )}
          </div>
        )}
      </div>
      {hasMoreInfo && (
        <div className={styles.moreInfo} onClick={onInfoClick}>
          {t('moreInfo')}
        </div>
      )}
    </div>
  );
};

export default EventProductCard;
